export default __webpack_public_path__ + "static/media/20_relaxing_bath.dcc26ece.png";